import axios from "axios";
import { API_BASE_URL } from "../config";

//Booking
async function createBooking(bookingData) {
    try {
        const authToken = localStorage.getItem('authToken');
        const user = JSON.parse(localStorage.getItem('user'));
        const data = {
            ...bookingData,
            userId: user._id
        }
        const response = await axios.post(`${API_BASE_URL}/bookings`, data, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });
           
        const res = response.data;
        return res;
    } catch (error) {
        console.error('Error creating booking:', error);
        throw error;    
    }
}

async function getBookings() {
    try {
        const authToken = localStorage.getItem('authToken');
        const response = await axios.get(`${API_BASE_URL}/bookings`, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });

        const data = response.data;
        return data;
    } catch (error) {
        console.error('Error fetching bookings:', error);
        throw error;    
    }
}

async function updateBookingStatus(bookingId, status) {
    try {
        const authToken = localStorage.getItem('authToken');
        const response = await axios.put(`${API_BASE_URL}/bookings/${bookingId}`, { status }, {
            headers: {  
                'Authorization': `Bearer ${authToken}`,
            }
        }); 

        const data = response.data;
        return data;
    } catch (error) {
        console.error('Error updating booking status:', error);
        throw error;    
    }
}

async function deleteBooking(bookingId) {
    try {
        const authToken = localStorage.getItem('authToken');
        const response = await axios.delete(`${API_BASE_URL}/bookings/${bookingId}`, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        }); 
        
        const data = response.data;
        return data;
    }

    catch (error) {
        console.error('Error deleting booking:', error);
        throw error;    
    }
}

async function getUserBookings() {
     try {
        const authToken = localStorage.getItem('authToken');
        const user = JSON.parse(localStorage.getItem('user'))
        const response = await axios.get(`${API_BASE_URL}/bookings/my-bookings/${user._id}`, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });

        const data = response.data.bookings;
        return data;
    } catch (error) {
        console.error('Error fetching bookings:', error);
        throw error;    
    }
}
export {
    createBooking,
    getBookings,    
    updateBookingStatus,
    deleteBooking,
    getUserBookings
};  